

















































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import { namespace } from 'vuex-class';
import { MetaInfo } from 'vue-meta';
import createStoreModule from './store';
import { Breadcrumbs as BreadcrumbsLayout } from '@/components/layout';
import { VacanciesCard } from '@/components/parts/vacancies';
import { ListPageLayout } from '@/uikit';
import SiteMap from '@/components/layout/SiteMap.vue';
import { Yellow as FilterYellow } from '@/components/parts/filter';
import { ListLayout, PaginationLayout } from '@/components/parts/listlayout';
import { Paginator as PaginatorDefault } from '@/components/parts/pagination';
import SelectCount from '@/components/parts/catalog/list/count';
import { Sort as CatalogSort } from '@/components/parts/catalog/list';
import { breadcrumbsMixin, filterMixin } from '../mixins';
import pageLimitChange from '@/pages/mixin-list';
import mixinNav from '@/pages/mixin-nav';
import { SortNav, Sort, Context } from './types';
import {
  FILTER_MENU,
  DEFAULT_SORT,
  PAGE_SIZE,
  PAGE_NUMBER,
  STORE_MODULE_NAME,
  FETCH_ITEMS,
  LIMITS,
  INIT,
} from './consts';
import isArrayNotEmpty from '@/tools/isarraynotempty';

const Vacancies = namespace(STORE_MODULE_NAME);
const actions = mapActions(STORE_MODULE_NAME, [INIT]);
const fetch = actions[INIT];

@Component({
  components: {
    SiteMap,
    ListLayout,
    SelectCount,
    CatalogSort,
    FilterYellow,
    VacanciesCard,
    ListPageLayout,
    PaginationLayout,
    PaginatorDefault,
    BreadcrumbsLayout,
  },

  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,

  inheritAttrs: false,

  metaInfo(): MetaInfo {
    return {
      title: 'Каталог вакансий',
    };
  },
})
export default class VacanciesList extends Mixins(
  breadcrumbsMixin,
  filterMixin,
  pageLimitChange,
  mixinNav,
) {
  @Prop({ type: String, default: DEFAULT_SORT })
  readonly sort: string;

  @Prop({ type: [String, Number], default: PAGE_NUMBER })
  readonly page: string | number;

  @Prop({ type: String, default: PAGE_SIZE })
  readonly limit: string;

  @Vacancies.State count: number;
  @Vacancies.State items: Array<any>;

  public filterSubmit: boolean = false;
  public sortNav: SortNav = FILTER_MENU;

  get isContainData() {
    return isArrayNotEmpty(this.items);
  }

  get sortList() {
    return this.sortNav.map(({ text, value }: Sort) => {
      const to = {
        ...this.$route,
        query: {
          ...this.$route.query,
          sort: value,
        },
      };
      return { text, to, active: this.sort === value };
    });
  }

  get filterProps() {
    const { localFilterFields, localFilterValues } = this;
    const key = JSON.stringify(localFilterValues);
    return {
      key,
      route: 'vacancies',
      fields: localFilterFields,
      values: localFilterValues,
      hasSwitcher: false,
      title: 'Поиск вакансий',
    };
  }

  get localFilterValues() {
    const { filterValues, limit, sort } = this;
    const addedValues = {
      sort,
      limit,
    };
    return {
      ...filterValues,
      ...addedValues,
    };
  }

  get localFilterFields() {
    const { filterFields } = this;
    const addedFields = [
      { type: 'hidden', code: 'sort' },
      { type: 'hidden', code: 'limit' },
    ];
    return [...filterFields, ...addedFields];
  }

  get pageLimits() {
    return LIMITS.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }

  get pageLimit() {
    return parseInt(this.limit);
  }

  get pagesCount() {
    return Math.ceil(this.count / this.pageLimit);
  }

  toggleFilterSubmit(): void {
    this.filterSubmit = true;
  }

  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = {
      page: PAGE_NUMBER,
      limit: PAGE_SIZE,
      ...route.query,
      ...route.params,
    };
    return fetch.call(context, params);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/vacancies/list/VacanciesList.vue